var map = {
	"./de/general7/slide5.svg": 865472,
	"./en/general7/slide5.svg": 648556,
	"./es/general7/slide5.svg": 911493,
	"./fr/general7/slide5.svg": 334717,
	"./nl/general7/slide5.svg": 978731,
	"./pt/general7/slide5.svg": 412665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77958;